import React from 'react';
import { Form, Checkbox, Tooltip } from '../../../../../components';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { NameField, UsernameField } from '../../cloudAccountFields';
import { TestConnectionButton } from '../../cloudAccountFields';
import TagsSelector from '../../../../TagsSelector';
import { getHelpLink } from '../../utils/cloudAccountHelpers';
import './GCPCloudAccount.scss';

/**
 * GCP Cloud Account - Add Mode
 * Focused component for adding new GCP cloud accounts
 */
export const GCPCloudAccountAdd = ({
    formData,
    errors,
    onChange,
    onTestConnection,
    testing,
    tested,
    onDownloadTemplate,
    tags,
    onTagsChange,
    userOrg,
    setupAppliance,
    onSetupApplianceChange,
}) => {
    return (
        <>
            <NameField value={formData.name} onChange={onChange('name')} error={errors.name} />

            <UsernameField
                value={formData.username}
                onChange={onChange('username')}
                label="Google Service Account"
                placeholder="Enter Google Service Account (required)"
                tooltip="Enter the Google Service Account email associated with the project."
                error={errors.username}
                required={true}
            />

            {/* GCP Helper Links */}
            <div className="gcp-helper-links">
                <a
                    href={getHelpLink('GCP_APPLIANCE_DOCS')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="gcp-link"
                >
                    View Instructions
                </a>
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onDownloadTemplate('gcp');
                    }}
                    className="gcp-link"
                >
                    Download Template
                </a>
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onDownloadTemplate('gcp', 'shared_vpc');
                    }}
                    className="gcp-link"
                >
                    Download Shared VPC Template
                </a>
            </div>

            {/* Test Connection - Required for GCP */}
            <TestConnectionButton
                onTest={onTestConnection}
                testing={testing}
                tested={tested}
                error={errors.testing}
                tooltip="Connection must be validated before you can Add Target Cloud. The connection and login credentials are tested (SSL certification is ignored)."
                required={true}
            />

            {/* Tags */}
            <Form.Item label="Tags">
                <TagsSelector value={tags} onChange={onTagsChange} userOrg={userOrg} />
            </Form.Item>

            {/* Setup Appliance */}
            <Form.Item>
                <Checkbox checked={setupAppliance} onChange={(e) => onSetupApplianceChange(e.target.checked)}>
                    Setup Migration Appliance for this target cloud{' '}
                    <Tooltip title="A Migration Appliance must be deployed for each target. Leave this checked to setup the Migration Appliance after you complete this form.">
                        <QuestionCircleOutlined />
                    </Tooltip>
                </Checkbox>
            </Form.Item>
        </>
    );
};
